import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'underscore';
import { CostingPageService } from '../costing-page.service';
interface apiCost {
  Phase: string,
  Value: string,
  Data: number;
  postData: any[];
}
@Component({
  selector: 'app-api-costingtable',
  templateUrl: './api-costingtable.component.html',
  styleUrls: ['./api-costingtable.component.scss']
})

export class ApiCostingtableComponent implements OnInit {

  apiData: any = []; //To Store the Subsribed API_Cost DATA
  refData: any = [] = []; // To Store the Updated format
  batch_downvalue: any = [];
  strength_dropdown: any = [];
  number_batches_dropdown: any = [];
  data: any[];
  enableNextButton = false;
  selectedSubMolecule: any;
  total: any;
  // apiCostData: any;

  constructor(private service: CostingPageService) { }

  ngOnInit(): void {
    // this.getDropdownValues();
    this.service.fetchcostAPI().subscribe((res: any) => {
      console.log(res);
      this.apiData = res.API_COST as apiCost
      //To Remove the Duplicates and group all values together
      // this.refData = _.chain(this.apiData).groupBy("Phase").map(function (offers, Phase) {
      //   var cleanOffers = _.map(offers, function (it) {
      //     return _.omit(it, "Phase");
      //   });

      //   return {
      //     Phase: Phase,
      //     Values: cleanOffers,
      //   };
      // }).value();
      console.log("ref data", this.refData);
    })
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach(DropdownValues => {
      let dropDownObj = {};
      dropDownObj['name'] = DropdownValues;
      dropDownObj['code'] = DropdownValues;
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray
  }


  @Input() name: string;
  @Input() MolData: any;
  @Input()
  public set apiCost(costdata) {
    if (costdata) {
      this.refData = _.chain(this.apiData).groupBy("Phase").map(function (offers, Phase) {
        var cleanOffers = _.map(offers, function (it) {
          return _.omit(it, "Phase");
        });

        return {
          Phase: Phase,
          Values: cleanOffers,
        };
      }).value();
      this.refData = this.refData.map(data => {
        if (data.Phase === "Development Phase") {
          data.batch_size = costdata.dev_phase.batch_size
          data.num_of_batches = costdata.dev_phase.num_of_batches
          data.sum_of_strengths = costdata.dev_phase.sum_of_strengths
          data.selectedBatch = costdata.dev_phase.batch_size[0]
          data.selectedNuberBatch = costdata.dev_phase.num_of_batches[0]
        }
        else if (data.Phase === "Pilot BE Phase") {
          data.batch_size = costdata.pilot_be_phase.batch_size
          data.num_of_batches = costdata.pilot_be_phase.num_of_batches
          data.sum_of_strengths = costdata.pilot_be_phase.sum_of_strengths
          data.selectedBatch = costdata.pilot_be_phase.batch_size[0]
          data.selectedNuberBatch = costdata.pilot_be_phase.num_of_batches[0]
        }
        else if (data.Phase === "Scale-up/Exhibit Batch Phase") {
          data.batch_size = costdata.scale_up_phase.batch_size
          data.num_of_batches = costdata.scale_up_phase.num_of_batches
          data.sum_of_strengths = costdata.scale_up_phase.sum_of_strengths
          data.selectedBatch = costdata.scale_up_phase.batch_size[0]
          data.selectedNuberBatch = costdata.scale_up_phase.num_of_batches[0]
        }
        return data;
      })
      this.dropDrownDataChange();
    }
  }
  @Output() callenableRegCostTab: EventEmitter<any> = new EventEmitter<any>();

  onClickNext() {
    this.callenableRegCostTab.emit();
  }

  onClickSubmit() {
    this.enableNextButton = true;

  }
  dropDrownDataChange() {
    const MData = this.MolData.split(',');
    let moleculeData: any = {
      "brand_name_or_proprietary_name": MData[0],
      "active_ingredient": MData[2],
      "nda_number": MData[1]
    }
    this.refData.map(data => {
      if (data.Phase === "Development Phase") {
        moleculeData = {
          ...moleculeData, "dev_phase": {
            "batch_size": data.selectedBatch,
            "num_of_batches": data.selectedNuberBatch,
            "sum_of_strengths": data.sum_of_strengths
          },
        }
      }
      else if (data.Phase === "Pilot BE Phase") {
        moleculeData = {
          ...moleculeData, "pilot_be_phase": {
            "batch_size": data.selectedBatch,
            "num_of_batches": data.selectedNuberBatch,
            "sum_of_strengths": data.sum_of_strengths
          },
        }
      }
      else if (data.Phase === "Scale-up/Exhibit Batch Phase") {
        moleculeData = {
          ...moleculeData, "scale_up_phase": {
            "batch_size": data.selectedBatch,
            "num_of_batches": data.selectedNuberBatch,
            "sum_of_strengths": data.sum_of_strengths
          },
        }
      }
    })
    this.service.getCostAPI(moleculeData).subscribe((resp: any) => {
      if (resp.data) {
        this.total = resp.data.total_api_cost_in_kg;
        this.refData = this.refData.map(data => {
          if (data.Phase === "Development Phase") {
            data.total = resp.data.dev_phase.total_api_in_kg
          }
          else if (data.Phase === "Pilot BE Phase") {
            data.total = resp.data.pilot_be_phase.total_api_in_kg
          }
          else if (data.Phase === "Scale-up/Exhibit Batch Phase") {
            data.total = resp.data.scale_up_phase.total_api_in_kg
          }
          return data;
        })
      }

    })
  }
}
